<template>
    <modal @close="$emit('close')" ref="modal">
        <template v-slot:title>TCP+ Employee Roles — {{ integration.client.name }}</template>

        <slot>
            <div v-if="loading" class="text-center my-3">
                <i class="far fa-spinner fa-spin"></i> Loading employees from TCP+...
            </div>

            <div v-if="errorMsg" class="alert alert-danger py-2">
                {{ errorMsg }}
            </div>

            <div v-if="!loading && !errorMsg && summary">
                <p class="text-muted">
                    <strong>Total:</strong> {{ summary.total }}
                    &nbsp;·&nbsp;
                    <strong>Active:</strong> {{ summary.total_active }}
                    &nbsp;·&nbsp;
                    <strong>Suspended:</strong> {{ summary.total_suspended }}
                </p>

                <p class="text-muted small">
                    roleId is the 2-character state/province code of the employee's home store
                    (CA, OH, TX, etc.). Used by TCP+ to apply state-specific labor rules.
                </p>

                <table class="table table-sm table-bordered" style="max-width: 320px;">
                    <thead>
                        <tr>
                            <th>roleId</th>
                            <th class="text-end">Count</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="roleId in sortedRoleIds" :key="roleId">
                            <td>
                                <span v-if="roleId">{{ roleId }}</span>
                                <span v-else class="text-muted">(blank)</span>
                            </td>
                            <td class="text-end">{{ summary.by_role_id[roleId] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </slot>

        <template v-slot:footer>
            <div class="form-row">
                <div class="col">
                    <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Close</button>
                </div>
                <div class="col">
                    <button type="button" class="btn btn-block btn-primary" @click.prevent="fetchSummary()" :disabled="loading">Refresh</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import api from '@/api'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    mixins: [ModalMixin],
    props: ['client', 'integration'],
    data() {
        return {
            loading: false,
            errorMsg: '',
            summary: null,
        }
    },
    computed: {
        sortedRoleIds() {
            if (!this.summary) return []
            return Object.keys(this.summary.by_role_id).sort((a, b) => {
                // sort by count desc, then alpha
                const ca = this.summary.by_role_id[a]
                const cb = this.summary.by_role_id[b]
                if (ca !== cb) return cb - ca
                return (a || 'zz').localeCompare(b || 'zz')
            })
        },
    },
    methods: {
        reset() {
            this.summary = null
            this.errorMsg = ''
            this.fetchSummary()
        },
        fetchSummary() {
            this.loading = true
            this.errorMsg = ''
            const url = `/admin/posintegrations/${this.integration.id}/tcpplus/roles`
            api.get(url).then(resp => {
                this.summary = resp
                this.loading = false
            }).catch(errors => {
                this.errorMsg = (errors.__all__ && errors.__all__[0]) || 'Failed to load roles.'
                this.loading = false
            })
        },
    },
}
</script>
